import { createBrowserHistory } from "@tanstack/react-router";

// The router and non-component auth redirects must use the same history instance.
export const history = createBrowserHistory();
